"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotspotPinComponentSchema = exports.HotspotImageSchema = exports.HotspotIconSchema = void 0;
const zod_1 = require("zod");
const base_pin_component_1 = require("./base-pin-component");
const tiptap_content_schema_1 = require("../tiptap-content.schema");
const shadow_setting_1 = require("../setting/shadow-setting");
const transparency_setting_1 = require("../setting/transparency-setting");
const HotspotFillTypeSchema = zod_1.z.enum(['ICON', 'IMAGE', 'TEXT']);
const HotspotExpandDirectionSchema = zod_1.z.enum(['AUTO', 'LEFT_DOWN', 'LEFT_UP', 'RIGHT_DOWN', 'RIGHT_UP']);
exports.HotspotIconSchema = zod_1.z.enum([
    'ACCOUNT',
    'ACTIVITY',
    'ADD',
    'APPS',
    'ARROW_BACK',
    'ARROW_BEND_DOWN_RIGHT',
    'ARROW_DOWN',
    'ARROW_FORWARD',
    'ARROW_UP',
    'AUDIO',
    'BADGE',
    'BOOK',
    'CALENDAR',
    'CAMERA',
    'CART',
    'CHEVRON_DOWN',
    'CHEVRON_LEFT',
    'CHEVRON_RIGHT',
    'CHEVRON_UP',
    'CLOSE',
    'CLOUD',
    'COINS',
    'COLOR',
    'COOKIE',
    'CUT',
    'DELETE',
    'DESKTOP',
    'EDIT',
    'EMAIL',
    'EURO',
    'EYE',
    'FEEDBACK',
    'FILE',
    'FILE_TEXT',
    'FLAG',
    'FOLDER',
    'HAND_RAISED',
    'HEADPHONES',
    'HEART_OUTLINE',
    'HELP',
    'HOME',
    'IMAGE',
    'INFINITY',
    'INFO',
    'LANGUAGE',
    'LAPTOP',
    'LINK',
    'LOCK',
    'LOCK_OPEN',
    'LUNCH',
    'MAP',
    'MEDIA_LIBRARY',
    'MICROPHONE',
    'MINUS',
    'NOTE',
    'NOTIFICATIONS',
    'PAYMENT',
    'PENSION',
    'PEOPLE',
    'PLAY',
    'PRESENT',
    'PRESENTER',
    'PRINT',
    'PRIVACY',
    'QUESTION',
    'REPORT',
    'ROBOT',
    'ROCKET',
    'SCHOOL',
    'SEARCH',
    'SEND',
    'SHARE_ALT',
    'SHOPPING_BAG',
    'STAR_OUTLINE',
    'STUDENT',
    'STUDENT_HAT',
    'SUN',
    'SUPPORT',
    'TEST',
    'TRAFFIC',
    'TRANSPORT',
    'VIDEO',
    'VOUCHER',
    'WAND',
    'WARNING',
]);
exports.HotspotImageSchema = zod_1.z.object({
    name: zod_1.z.string(),
    url: zod_1.z.string(),
});
const HotspotSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    body: tiptap_content_schema_1.TipTapContentSchema,
    fillType: HotspotFillTypeSchema,
    iconFill: exports.HotspotIconSchema,
    imageFill: exports.HotspotImageSchema,
    linkedPinComponent: zod_1.z.string().nullish(),
    showBody: zod_1.z.boolean(),
    expandDirection: HotspotExpandDirectionSchema,
    textFill: zod_1.z.string(),
    title: tiptap_content_schema_1.TipTapContentSchema,
    backgroundColor: zod_1.z.string().optional(),
    innerColor: zod_1.z.string().optional(),
    contentBackgroundColor: zod_1.z.string().optional(),
    contentTextColor: zod_1.z.string().optional(),
    borderSize: zod_1.z.number().optional(),
    borderColor: zod_1.z.string().optional(),
    borderRadius: zod_1.z.number().optional(),
    shadow: shadow_setting_1.ShadowSettingKeySchema,
    transparency: transparency_setting_1.TransparencySettingSchema,
}));
exports.HotspotPinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('HOTSPOT'),
    settings: HotspotSettingsSchema,
}));
//# sourceMappingURL=hotspot-pin-component.js.map